import { initRouter } from "./router/router.js";
import "./styles.css";

initRouter();
